import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z","key":"svg-0"}],["path",{"d":"M15 12h-6","key":"svg-1"}],["path",{"d":"M12 9v6","key":"svg-2"}]]

const IconSquareRoundedPlus = createReactComponent('outline', 'square-rounded-plus', 'SquareRoundedPlus', __iconNode);

export default IconSquareRoundedPlus;